import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  imports: [RouterOutlet],
  templateUrl: './authentication.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AuthenticationComponent { }
